import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthShell from "@/components/AuthShell";

const inputCls = "w-full bg-surface-2 border border-border rounded-md px-4 py-3 text-fg text-sm focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-accent/40 transition-shadow";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Recevez un lien de réinitialisation par email."
      footer={<Link to="/login" className="text-accent hover:underline" data-testid="link-back-login">Retour à la connexion</Link>}
    >
      {sent ? (
        <div className="surface rounded-md p-6 text-sm text-fg/90" data-testid="forgot-sent">
          Si un compte existe pour <span className="text-accent">{email}</span>, un email de réinitialisation vient d'être envoyé.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <label className="overline block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="vous@esn.fr" data-testid="forgot-email" />
          </div>
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full bg-accent text-black font-semibold py-3 rounded-md hover-lift disabled:opacity-60">
            {loading ? "Envoi…" : "Envoyer le lien"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
